import React, { FC, useEffect } from 'react'
import PGraph from './PGraph'
import Chart from 'react-chartjs-2'
import { Track } from '../../models/track'
import { RootState } from '../../store/reducers'
import { connect } from 'react-redux'
import { getUserTracks } from '../../store/actions/users'

interface DProps {
  tracks: Track[]
  username: string
  getUserTracks: Function
}

const Dashboard: FC<DProps> = ({ tracks, username, getUserTracks }) => {
  useEffect(() => {
    getUserTracks(username)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  document.getElementsByTagName('title')[0].innerHTML = 'dashboard'

  return (
    <div className="app-view-body" id="dashboard">
      <div className="dashboard-item  uk-margin-large-bottom uk-border-rounded ">
        <div className="app-text uk-flex uk-flex-between">
          <h4 className="app-text">Quick Insights</h4>
          <span className="uk-visible@s">
            <i className="material-icons-outlined">add</i>
          </span>
        </div>
        <div id="insights" className="dash-grid-item">
          <div className="insights-item">
            <span>
              <i className="material-icons-outlined thmcl">visibility</i>
              <span>6</span>
            </span>
            <span>Profile Visits</span>
          </div>
          <div className="insights-item">
            <span>
              <i className="material-icons-outlined thmcl">search</i>9
            </span>
            <span>Search Appearances</span>
          </div>
          <div className="insights-item">
            <span>
              <i className="material-icons-outlined thmcl">play_arrow</i>
              {tracks.length > 1
                ? tracks.reduce((a, b) => {
                    b.plays = [...b.plays, ...a.plays]
                    return b
                  }).plays.length
                : 0}
            </span>
            <span>Plays</span>
          </div>
          <div className="insights-item">
            <span>
              <i className="material-icons-outlined thmcl">how_to_reg</i>3
            </span>
            <span>New fans</span>
          </div>
          <div className="insights-item">
            <span>
              <i className="material-icons-outlined thmcl">favorite_border</i>8
            </span>
            <span>Likes</span>
          </div>
          <div className="insights-item">
            <span>
              <i className="material-icons-outlined thmcl">add</i>1
            </span>
            <span>Playlist adds</span>
          </div>
        </div>
      </div>
      {/* <div className="dashboard-item  uk-margin-large-bottom uk-border-rounded uk-box-shadow-large"> */}
      <div className="uk-margin-large-bottom">
        <>
          <div>
            <div>
              <h4 style={{ color: 'black' }}>Overall performance</h4>
            </div>
            <div className="performance-chart uk-margin-medium-top">
              <div className="uk-hidden@s">
                <PGraph />
              </div>
              <div
                style={{
                  width: '90%',
                  height: '90%',
                  margin: 'auto',
                }}
              >
                <Chart
                  type="line"
                  width={400}
                  height={300}
                  data={{
                    labels: [
                      'jan',
                      'feb',
                      'mar',
                      'apr',
                      'may',
                      'jun',
                      'jul',
                      'aug',
                      'sep',
                      'oct',
                      'nov',
                      'dec',
                    ],
                    datasets: [
                      {
                        label: 'Plays',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'orange',
                        borderColor: 'orange',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'orange',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 1,
                        pointHoverRadius: 5,
                        pointHoverBackgroundColor: 'orange',
                        pointHoverBorderColor: 'rgba(220,220,220,1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        data: [
                          355,
                          409,
                          500,
                          456,
                          535,
                          264,
                          534,
                          547,
                          353,
                          642,
                          455,
                          400,
                        ],
                      },
                      {
                        label: 'Likes',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'green',
                        borderColor: 'green',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'green',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 1,
                        pointHoverRadius: 5,
                        pointHoverBackgroundColor: 'green',
                        pointHoverBorderColor: 'rgba(220,220,220,1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        data: [30, 55, 68, 45, 34, 27, 43, 23, 13, 12, 19, 5],
                      },
                      {
                        label: 'Playlist',
                        fill: false,
                        lineTension: 0.1,
                        backgroundColor: 'blue',
                        borderColor: 'blue',
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: 'blue',
                        pointBackgroundColor: '#fff',
                        pointBorderWidth: 1,
                        pointHoverRadius: 5,
                        pointHoverBackgroundColor: 'blue',
                        pointHoverBorderColor: 'rgba(220,220,220,1)',
                        pointHoverBorderWidth: 2,
                        pointRadius: 1,
                        pointHitRadius: 10,
                        data: [23, 43, 44, 16, 44, 36, 47, 7, 16, 38, 49, 34],
                      },
                    ],
                  }}
                />
              </div>

              {/* <div
              id="p-chart"
              className="uk-visible@s"
              style={{ height: `400px` }}
            ></div> */}
            </div>
          </div>
        </>
      </div>
      {/* </div> */}
      <div className="dashboard-item  uk-margin-large-bottom  uk-border-rounded">
        <div>
          <h4 className="app-text">For you</h4>
        </div>
        <div id="for-you" className=" uk-border-rounded">
          <div>
            <h5 className="app-text">Notifications</h5>
            <ul className="uk-list">
              <li>You have 2 new fans</li>
              <li>Farnsworth added your track to playlist</li>
              <li>Fry liked your track</li>
            </ul>
            <button className="uk-button uk-border-rounded">
              View more...
            </button>
          </div>
          <div>
            <h5 className="app-text">Messages</h5>
            <ul className="uk-list">
              <li>Congratulations, You have 1000 fans</li>
              <li>Your tracks reached 500 </li>
              <li>Promote your content today</li>
            </ul>
            <button className="uk-button uk-border-rounded">
              View more...
            </button>
          </div>
          <div>
            <h5 className="app-text">Promotions</h5>
            <div className="promo">
              <div>
                <span>
                  <i className="material-icons-outlined">add</i>
                </span>
                <div>Add Method</div>
              </div>
              <div>
                <i className="material-icons-outlined">settings</i>
                <div>Manage</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state: RootState) => ({
  tracks: state.data.userTracks,
  username: state.auth.user.username,
})

export default connect(mapStateToProps, { getUserTracks })(Dashboard)
